




import Vue from 'vue'
export default Vue.extend({
  name: 'integrated-info-base',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
})
